import React from 'react';
import { useStore, FAQ, Objection } from '../../store/useStore';
import { Input, Repeater, Textarea } from '../ui';
import { Bot, MessageSquare, ShieldAlert } from 'lucide-react';

export function M12_Automations() {
  const { automations, setAutomations } = useStore();

  const handleAddFaq = () => {
    setAutomations({
      ...automations,
      faqs: [...automations.faqs, { id: Date.now().toString(), pergunta: '', resposta: '' }]
    });
  };

  const handleRemoveFaq = (index: number) => {
    setAutomations({
      ...automations,
      faqs: automations.faqs.filter((_, i) => i !== index)
    });
  };

  const handleChangeFaq = (id: string, field: keyof FAQ, value: string) => {
    setAutomations({
      ...automations,
      faqs: automations.faqs.map(f => f.id === id ? { ...f, [field]: value } : f)
    });
  };

  const handleAddObjection = () => {
    setAutomations({
      ...automations,
      objecoes: [...automations.objecoes, { id: Date.now().toString(), topico: '', resposta: '' }]
    });
  };

  const handleRemoveObjection = (index: number) => {
    setAutomations({
      ...automations,
      objecoes: automations.objecoes.filter((_, i) => i !== index)
    });
  };

  const handleChangeObjection = (id: string, field: keyof Objection, value: string) => {
    setAutomations({
      ...automations,
      objecoes: automations.objecoes.map(o => o.id === id ? { ...o, [field]: value } : o)
    });
  };

  return (
    <div className="space-y-8 animate-in fade-in duration-500">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-6">
        <Repeater
          title="Perguntas Frequentes (FAQ e Bot)"
          description="Cadastre as respostas padronizadas para treinar IA ou criar mensagens rápidas no WhatsApp."
          items={automations.faqs}
          onAdd={handleAddFaq}
          onRemove={handleRemoveFaq}
          addButtonText="Adicionar Pergunta"
          getItemSummary={(item) => ({
            title: item.pergunta || 'Nova Pergunta',
            subtitle: item.resposta
          })}
          renderItem={(faq) => (
            <div className="space-y-4">
               <Input 
                   label="Pergunta do Usuário" 
                   value={faq.pergunta} 
                   onChange={(e) => handleChangeFaq(faq.id, 'pergunta', e.target.value)} 
                   placeholder="Ex: Qual o horário de funcionamento?" 
               />
               <div className="bg-gray-50 p-2 rounded-lg border border-gray-100 flex items-start gap-3">
                   <div className="w-8 h-8 rounded-full bg-indigo-100 flex-shrink-0 flex items-center justify-center text-indigo-600 mt-1">
                       <Bot size={16} />
                   </div>
                   <div className="flex-1">
                       <Textarea 
                           label="" 
                           value={faq.resposta} 
                           onChange={(e) => handleChangeFaq(faq.id, 'resposta', e.target.value)} 
                           placeholder="Cole a resposta padrão aqui..." 
                           className="min-h-[100px] border-none bg-white shadow-sm"
                       />
                   </div>
               </div>
            </div>
          )}
        />
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-6">
        <Repeater
          title="Quebra de Objeções (Scripts para Venda)"
          description="Como o time lida quando o cliente diz não?"
          items={automations.objecoes}
          onAdd={handleAddObjection}
          onRemove={handleRemoveObjection}
          addButtonText="Adicionar Objeção"
          getItemSummary={(item) => ({
            title: item.topico || 'Nova Objeção',
            subtitle: item.resposta
          })}
          renderItem={(obj) => (
            <div className="space-y-4">
               <Input 
                   label="Tópico / Objeção" 
                   value={obj.topico} 
                   onChange={(e) => handleChangeObjection(obj.id, 'topico', e.target.value)} 
                   placeholder="Ex: 'Tá caro' / Concorrência é mais barata" 
               />
               <div className="bg-orange-50 p-2 rounded-lg border border-orange-100 flex items-start gap-3">
                   <div className="w-8 h-8 rounded-full bg-orange-100 flex-shrink-0 flex items-center justify-center text-orange-600 mt-1">
                       <ShieldAlert size={16} />
                   </div>
                   <div className="flex-1">
                       <Textarea 
                           label="" 
                           value={obj.resposta} 
                           onChange={(e) => handleChangeObjection(obj.id, 'resposta', e.target.value)} 
                           placeholder="Script do vendedor para reverter essa objeção..." 
                           className="min-h-[100px] border-none bg-white shadow-sm"
                       />
                   </div>
               </div>
            </div>
          )}
        />
      </div>
    </div>
  );
}
